import { Broadcast, DeviceMobile, Airplay, Television, WifiHigh } from "@phosphor-icons/react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "@/components/ui/dialog";

const Step = ({ icon, title, children }) => (
  <div className="flex gap-4">
    <div className="mt-0.5 shrink-0 text-amber">{icon}</div>
    <div>
      <p className="font-serif text-lg text-[#EDEDED] leading-tight">{title}</p>
      <p className="mt-1 text-sm text-white/55 leading-relaxed">{children}</p>
    </div>
  </div>
);

export const CastHelpModal = ({ trigger }) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {trigger || (
          <button
            data-testid="cast-help-btn"
            className="flex items-center gap-2 border border-white/15 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.15em] text-white/70 hover:border-amber hover:text-amber transition-colors duration-300"
          >
            <Airplay size={16} weight="duotone" /> <span className="rv-hdr-label hidden min-[1700px]:inline whitespace-nowrap">Cast / Mirror</span>
          </button>
        )}
      </DialogTrigger>
      <DialogContent
        data-testid="cast-help-modal"
        className="max-w-xl bg-black/80 backdrop-blur-md border-white/10 text-left"
      >
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl tracking-tight text-[#EDEDED] flex items-center gap-3">
            <Broadcast size={26} weight="duotone" className="text-amber" />
            Cast &amp; Mirror to your TV
          </DialogTitle>
          <DialogDescription className="text-white/50">
            Watch ReelVault on the big screen — cast a video, mirror your phone, or open it in your TV browser.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 space-y-6">
          <Step icon={<Airplay size={26} weight="duotone" />} title="Cast a video directly (Chromecast)">
            When a film is playing, tap the <span className="text-amber">Cast icon</span> inside the video player
            itself — it appears on supported browsers and sends the video straight to your Chromecast or Google TV.
          </Step>

          <Step icon={<DeviceMobile size={26} weight="duotone" />} title="Mirror your phone screen">
            <span className="text-amber">Android:</span> open Quick Settings → “Cast / Screen Cast” and pick your TV.
            <br />
            <span className="text-amber">iPhone / iPad:</span> open Control Centre → “Screen Mirroring” → choose your
            AirPlay TV or Apple TV. ReelVault then fills the big screen.
          </Step>

          <Step icon={<Television size={26} weight="duotone" />} title="Fire Stick / Smart TV browser">
            Open the <span className="text-amber">Silk browser</span> on your Fire Stick, go to ReelVault and bookmark it.
            Turn on <span className="text-amber">TV Mode</span> and use the remote’s arrow pad + OK button to browse —
            no mouse needed.
          </Step>

          <Step icon={<WifiHigh size={26} weight="duotone" />} title="Same Wi-Fi network">
            Make sure your phone / laptop and the TV are on the <span className="text-amber">same Wi-Fi</span>, otherwise
            the cast and mirroring targets won’t show up.
          </Step>
        </div>

        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.15em] text-white/30">
          Casting is handled by your device &amp; the video provider — ReelVault stays lightweight and reliable.
        </p>
      </DialogContent>
    </Dialog>
  );
};
